import React, {Fragment} from 'react';
import Popup from 'components/popups/popup';
import I18n from 'lib/i18n/i18n';
import UserActions from "lib/userActions";

export default class PopupJBSuccessFees extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        UserActions.myAccount('JB bundle fees popup presented', this.props.bundleId, 'Bundle');
    }

    title() {
        return I18n.getString('myAccount::popups::successFees::title');
    }

    _hide() {
        UserActions.myAccount('JB bundle fees popup closed', this.props.bundleId, 'Bundle');
        super._hide();
    }

    content() {
        return (
            <Fragment>
                <p>{I18n.getString('myAccount::popups::successFees::p1')}</p>
                <p dangerouslySetInnerHTML={{__html:I18n.getString('myAccount::popups::successFees::p2')}}/>
            </Fragment>
        );
    }
}
PopupJBSuccessFees.defaultProps = {
    popupClassName: 'popup-tooltip popup-jb-success-fee popup-compact',
    single: true,
    modal: true,
    classNames: ['no-animation']
};